import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class roleService {
  private token: string | null = localStorage.getItem('token');
  private roles: string[] = [];         // Rôles "realm_access"
  private rolesClient: string[] = [];   // Rôles "resource_access"

  constructor() {
    if (this.token) {
      this.decodeToken();
    }
  }

  // Décode le token JWT pour extraire les rôles Keycloak (realm + clients dynamiques)
  private decodeToken(): void {
    const token = this.token;
    if (!token) return;

    const decoded: any = jwtDecode(token);

    // 1. Rôles généraux
    this.roles = decoded.realm_access?.roles || [];

    // 2. Rôles clients (resource_access dynamiquement)
    this.rolesClient = [];

    const resourceAccess = decoded.resource_access;
    if (resourceAccess && typeof resourceAccess === 'object') {
      for (const clientName of Object.keys(resourceAccess)) {
        const clientRoles = resourceAccess[clientName]?.roles;
        if (Array.isArray(clientRoles)) {
          this.rolesClient.push(...clientRoles);
        }
      }
    }

    console.log("Roles généraux :", this.roles);
    console.log("Roles client :", this.rolesClient);
  }

  // Vérifie si un rôle "realm_access" est présent
  hasRole(role: string): boolean {
    return this.roles.includes(role);
  }

  // Vérifie si un rôle "client" (resource_access) est présent
  hasRoleClient(role: string): boolean {
    return this.rolesClient.includes(role);
  }

  // Méthodes pour tester des rôles spécifiques
  isAdmin(): boolean {
    return this.hasRole('ADMIN');
  }

  isEtudiants(): boolean {
    return this.hasRole('ETUDIANTS') ;
  }

  isEtudiant(): boolean {
    return this.hasRoleClient('ETUDIANTS') ;
  }

  ENSEIGNANT(): boolean {
    return this.hasRoleClient('ENSEIGNANTS') ;
  }

  ENSEIGNANTS(): boolean {
    return this.hasRole('ENSEIGNANTS') ;
  }

  CELLULE_INSAF(): boolean {
    return this.hasRole('CELLULE_INSAF');
  }

  CHEF_SERVICE(): boolean {
    return this.hasRole('CHEF_SERVICE');
  }

  DIRECTEUR(): boolean {
    return this.hasRole('DIRECTEUR');
  }

  PRESIDENT(): boolean {
    return this.hasRole('PRESIDENT');
  }

  RESPONSABLES_EES(): boolean {
    return this.hasRole('RESPONSABLES_EES');
  }

  RESPONSABLES_STRUCTURE_RECHERCHE(): boolean {
    return this.hasRole('RESPONSABLES_STRUCTURE_RECHERCHE');
  }

  SECRETAIRE_GENERAL(): boolean {
    return this.hasRole('SECRETAIRE_GENERAL');
  }

  SOUS_DIRECTEUR(): boolean {
    return this.hasRole('SOUS_DIRECTEUR');
  }

  VICE_PRESIDENT(): boolean {
    return this.hasRole('VICE_PRESIDENT');
  }

  VISITEUR(): boolean {
    return this.hasRole('VISITEUR');
  }

  isUser(): boolean {
    return this.hasRole('user');
  }

  // Accès au token
  getToken(): string | null {
    return this.token;
  }

  clearToken(): void {
    this.token = null;
  }

  clearRoles(): void {
    this.roles = [];
    this.rolesClient = [];
  }

  refreshRoles(): void {
    this.token = localStorage.getItem('token');
    if (this.token) {
      this.decodeToken();
    }
  }
}
